import { Clipboard, Check, Share2 } from "../../../Atoms/Icons";
import { buildMailto } from "../../../static/jobsHelpers";

function Section({ section }) {
  return (
    <div className="content-section pt-4 ">
      <h2 className="text-2xl ">{section.heading}</h2>
      {section.type === "paragraph" && <p className="text-xl mb-2">{section.body}</p>}
      {section.type === "list" && (
        <ul>{section.items.map((item) => <li className="text-xl mb-2" key={item}>{item}</li>)}</ul>
      )}
      {section.type === "labeled-list" && (
        <ul>
          {section.items.map((item) => (
            <li className="text-xl mb-2" key={item.label}><strong>{item.label}:</strong> {item.detail}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function MainContent({ job, allSections, overviewRows, copied, onCopyId, onShare }) {
  return (
    <section className="py-16 ">
      <div className="containers-min mx-auto px-4  grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-10 ">
        <div>
          {allSections.map((section) => <Section section={section} key={section.heading} />)}
        </div>

        <aside className="sidebar-card h-fit">
          <div className="flex justify-between  items-center mb-4 ">
            <h2 className="text-lg font-bold  ">Job Overview</h2>
            <button
              type="button"
              onClick={onShare}
              className="share-btn share-btn-whatsapp "
              aria-label="Share this job"
            >
              <Share2 size={18} />
            </button>
          </div>

          {overviewRows.map((row) => (
            <div className="row-line" key={row.label}>
              <span>{row.label}</span>
              {row.label === "Job ID" ? (
                <span className="flex items-center gap-2">
                  {row.value}
                  <button
                    type="button"
                    className={`copy-job-id-btn ${copied ? "copied" : ""}`}
                    onClick={() => onCopyId(row.value)}
                  >
                    {copied ? <Check size={12} /> : <Clipboard size={12} />}
                    {copied ? "Copied" : "Copy"}
                  </button>
                </span>
              ) : (
                <span>{row.value}</span>
              )}
            </div>
          ))}
          <a href={buildMailto(job)} className="btn-brand w-full mt-4 block text-center">Apply Now</a>
        </aside>
      </div>
    </section>
  );
}
